import React, { useEffect, useMemo, useState } from 'react'

import { doc, getDoc } from 'firebase/firestore'
import toast from 'react-hot-toast'
import {
  MdOutlinePauseCircleFilled,
  MdOutlinePlayCircleFilled,
} from 'react-icons/md'
import { TbHeadphones, TbHeadphonesOff } from 'react-icons/tb'

import { EqualizerIcon } from './EqualizerIcon'
import { useStudents, useUser } from '../../context'
import { firestore } from '../../firebase/firebaseConfig'
import { DeleteLogModal } from '../modal'
import { SectionSubtitle } from '../texts'

import { List, ListItem, SongList } from './styles'

const SPECIAL_EXERCISES = 'Ejercicios Especiales'

const SongsList = ({
  audiosList,
  handleSelectTrack,
  currentTrackIndex,
  currentRoutine,
  isPlaying,
  handlePlayPause,
}: {
  audiosList: {
    title: string
    url: string
    routine: string
    logUID: string
    visibility: boolean
  }[]
  handleSelectTrack: (index: number, routine: string) => void
  currentTrackIndex: number
  currentRoutine: string | null
  isPlaying: boolean
  handlePlayPause: () => void
}) => {
  const { userRole } = useUser()
  const { deleteExerciseByURLFromLog, activeStudent } = useStudents()
  const [routineTypes, setRoutineTypes] = useState<string[] | null>(null)
  const [showConfirmation, setShowConfirmation] = useState(false)
  const [deleteData, setDeleteData] = useState<{
    index: number
    exerURL: string
    logUID: string
  } | null>(null)

  const messsage = useMemo(() => {
    if (deleteData?.index === undefined) {
      return ''
    }

    return `¿Estás seguro de que quieres ${
      audiosList[deleteData.index].visibility ? 'ocultar' : 'mostrar'
    } este ejercicio?`
  }, [deleteData?.index])

  const getRoutinesTypes = async () => {
    // TODO: replace with
    // const menu = await guardedCall(() => getDoc(doc(firestore, 'lists', 'routineType')))
    try {
      const docRef = doc(firestore, 'lists', 'routineType')

      const docSnapshot = await getDoc(docRef)

      if (docSnapshot.exists()) {
        setRoutineTypes(docSnapshot.data().items)
      }
    } catch (error) {
      console.error('Error accediendo a la lista de entrenamiento:')
    }
  }

  useEffect(() => {
    getRoutinesTypes()
  }, [])

  const isActiveItem = (index: number, routine: string) => {
    return (
      currentTrackIndex === index && currentRoutine === routine && isPlaying
    )
  }

  const hasExercises = (filterValue: string) => {
    const filteredList = audiosList.filter(
      (song) => song.routine === filterValue,
    )
    return userRole === 'student'
      ? filteredList.filter((song) => song.visibility === true)
      : filteredList
  }

  const handleDelete = async (
    deleteData: {
      index: number
      exerURL: string
      logUID: string
    } | null,
  ) => {
    if (!deleteData) return
    if (activeStudent) {
      try {
        const deleteExer = await deleteExerciseByURLFromLog(
          activeStudent.uid,
          deleteData.logUID,
          deleteData.exerURL,
        )
        const message = deleteExer?.message || 'Operación completada'

        if (deleteExer.error) {
          toast.error(message)
        } else {
          toast.success(message)
        }
      } catch (error: unknown) {
        console.error('error', error)
        const message =
          error instanceof Error
            ? error.message
            : String(error ?? 'Error desconocido')
        toast.error(message)
      } finally {
        setShowConfirmation(false)
      }
    }
  }

  return (
    <SongList>
      {showConfirmation && (
        <DeleteLogModal
          handleClose={() => setShowConfirmation(false)}
          handleDelete={() => handleDelete(deleteData)}
          message={messsage}
          hasButton
        />
      )}
      {routineTypes?.map((routine, i) => {
        return (
          <List
            key={i}
            style={{
              display: hasExercises(routine).length > 0 ? 'flex' : 'none',
            }}
          >
            {routine !== SPECIAL_EXERCISES && (
              <SectionSubtitle fontSize={16} fontWeight={600}>
                {routine}
              </SectionSubtitle>
            )}

            {audiosList.map((song, index) => {
              if (userRole === 'student' && song.visibility === false) {
                return
              }
              if (routine === song.routine) {
                return (
                  <ListItem
                    key={index}
                    $studentVisibility={
                      userRole === 'student' ? song.visibility : true
                    }
                    $userRole={userRole}
                  >
                    <div
                      className="item"
                      onClick={() => handleSelectTrack(index, song.routine)}
                      style={{
                        cursor: 'pointer',
                        fontWeight: isActiveItem(index, song.routine)
                          ? 'bold'
                          : 'normal',
                      }}
                    >
                      {/* PONER EL EQUALIZADOR O PLAY PAUSE AL HOVER */}
                      {userRole === 'professor' ? (
                        <div onClick={handlePlayPause} className="play">
                          {isActiveItem(index, song.routine) && isPlaying ? (
                            <MdOutlinePauseCircleFilled />
                          ) : (
                            <MdOutlinePlayCircleFilled />
                          )}
                          <div></div>
                        </div>
                      ) : (
                        <div>
                          {isActiveItem(index, song.routine) && isPlaying ? (
                            <EqualizerIcon
                              isPlaying={
                                isActiveItem(index, song.routine) && isPlaying
                              }
                            />
                          ) : (
                            <div className="image"></div>
                          )}
                        </div>
                      )}

                      <p>{song.title}</p>

                      {userRole === 'professor' ? (
                        <button
                          className="delete-button"
                          onClick={(e) => {
                            e.stopPropagation()
                            setShowConfirmation(true)
                            setDeleteData({
                              index,
                              exerURL: song.url,
                              logUID: song.logUID,
                            })
                          }}
                        >
                          {song.visibility ? (
                            <TbHeadphones />
                          ) : (
                            <TbHeadphonesOff />
                          )}
                        </button>
                      ) : (
                        <div onClick={handlePlayPause} className="play">
                          {isActiveItem(index, song.routine) && isPlaying ? (
                            <MdOutlinePauseCircleFilled />
                          ) : (
                            <MdOutlinePlayCircleFilled />
                          )}
                          <div></div>
                        </div>
                      )}
                    </div>
                  </ListItem>
                )
              }
            })}
          </List>
        )
      })}
    </SongList>
  )
}
export default SongsList
